export const ORG_INTERFACE_ERROR_RATE_CONTRACT = {
  title: 'Top raw error/discard packet rate',
  intent: 'interface.error_discard_rate_top10_5m',
  topKLimit: 10
} as const;

export const ORG_INTERFACE_ERROR_COVERAGE_CONTRACT = {
  // Internal metrics-gateway intent catalog entry; this is not a new public
  // OpenAPI schema and must remain aligned with specs/intents/interface_util.yaml.
  intent: 'interface.error_discard_presence_5m'
} as const;
